module.exports = __webpack_public_path__ + "a944e523101b40f4e14a268fdfbcfb07.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_r_60.mp3
// module id = 431
// module chunks = 0